import { ApiConflictError } from '@/lib/api-client';
import { structuredDetail } from './dispatch-gate';

/** The server's own message when a write was refused because the product is archived
 *  (409 with `reason: "product_archived"`), else null — so a screen can say "archived"
 *  instead of its generic "changed elsewhere" for an optimistic-concurrency 409. The
 *  client keeps the whole response body, so the reason sits under its `detail`. */
export function archivedProductMessage(err: unknown): string | null {
  return err instanceof ApiConflictError && structuredDetail(err)?.reason === 'product_archived'
    ? err.message
    : null;
}
